<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de Condutor">
            <template v-slot:actions>
                <rkm-button
                    @click="$router.push({ name: 'transporte-paciente-condutor-create' })"
                    autorize="store-transporte-paciente-condutor"
                    color="primary"
                >
                    Cadastrar condutor
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>

// Components.
import List from '@/components/transporte-paciente/condutor/List'

export default {
    components: { List },
}
</script>